import { getTradingReaderFacet } from '@ui/services/contract/contract-instances/getTradingReaderFacet';
import type { Address } from '@ui/types/alias';
import type { ChainId } from '@ui/types/chain';
import type { PublicClient } from 'viem';

import type { DecreaseOrderRow } from './types';

export const GET_DECREASE_ORDERS = 'TradingPortalFacet.getDecreaseOrders';

const toOrderKind = (kind: number): DecreaseOrderRow['kind'] => {
  return kind === 0 ? 'TP' : 'SL';
};

type ContractDecreaseOrder = {
  orderHash: Address;
  positionHash: Address;
  user: Address;
  pairBase: Address;
  isLong: boolean;
  kind: number;
  triggerPrice: bigint;
  closeQty: bigint;
  broker: number;
  createdAt: number;
  active: boolean;
};

const toDecreaseOrderRow = (order: ContractDecreaseOrder): DecreaseOrderRow => {
  return {
    orderHash: order.orderHash,
    user: order.user,
    positionHash: order.positionHash,
    pairBase: order.pairBase,
    isLong: order.isLong,
    kind: toOrderKind(order.kind),
    triggerPrice: order.triggerPrice,
    closeQty: order.closeQty,
    broker: order.broker,
    createdAt: order.createdAt,
    active: order.active,
    status: order.active ? 'ACTIVE' : 'CANCELLED',
  };
};

export const decreaseOrdersQuery = {
  getQueryKey: ({
    chainId,
    user,
    positionHash,
    clientUid,
  }: {
    chainId: ChainId;
    user?: Address;
    positionHash?: Address;
    clientUid?: string;
  }) => [GET_DECREASE_ORDERS, chainId, user, positionHash, clientUid],
  getQueryFn:
    ({
      chainId,
      client,
      user,
      positionHash,
    }: {
      chainId: ChainId;
      client?: PublicClient;
      user: Address;
      positionHash?: Address;
      fromBlock?: bigint;
    }) =>
    async () => {
      if (!client) {
        throw new Error('Client missing');
      }

      const contract = getTradingReaderFacet({
        publicClient: client,
        chainId,
      });
      const readerOrders = positionHash
        ? await contract.read.getDecreaseOrders([positionHash])
        : await contract.read.getTraderDecreaseOrders([user]);

      return (readerOrders as ContractDecreaseOrder[]).map(toDecreaseOrderRow);
    },
};
